import {APIRequest, callAPI} from "./axiosDriver"
import {PhoneEntity} from "scholastic-client-components/src/features/PhoneInput/types"
import {PersonLocale} from "scholastic-client-components/src/slices/authSlice"

interface CheckAccountRequest {
    email: string
    deviceId: string
}

export interface CheckAccountResponse {
    accountExists: boolean
    accountConfirmed: boolean
}

const checkAccount: APIRequest<CheckAccountRequest, CheckAccountResponse> = (params) => {
    return callAPI({url: "/api/user/checkAccount", ...params})
}

interface ResendConfirmEmailRequest {
    email: string
}

const resendConfirmEmail: APIRequest<ResendConfirmEmailRequest> = (params) => {
    return callAPI({url: "/api/user/resendConfirmEmail", ...params})
}

interface CreateAccountRequest {
    firstName: string
    lastName: string
    email: string
    phone?: PhoneEntity
    password: string
    deviceId?: string
    acceptTOS: boolean
    locale: PersonLocale
}

const createAccount: APIRequest<CreateAccountRequest> = (params) => {
    return callAPI({url: "/api/user/createAccount", ...params})
}

interface ConfirmAccountRequest {
    token?: string
}

interface ConfirmAccountResponse {
    deviceId?: string
}

const confirmAccount: APIRequest<ConfirmAccountRequest, ConfirmAccountResponse> = (params) => {
    return callAPI({url: "/api/user/confirmAccount", ...params})
}

interface ResendTFARequest {
    email: string
}

const resendTFA: APIRequest<ResendTFARequest> = (params) => {
    return callAPI({url: "/api/user/resendTFA", ...params})
}

export const userAPI = {
    checkAccount,
    resendConfirmEmail,
    createAccount,
    confirmAccount,
    resendTFA,
}
